import {
    ADBLOCK_EXOCLICK,
    ADBLOCK_PROPELLER,
    TRAFFIC_SOURCE_EXOCLICK,
    TRAFFIC_SOURCE_PROPELLER,
} from '@/constants';
import { store, quizStore } from '@/store';
export const submitQuiz = {
    data() {
        return {
            storeState: store.state,
            quizState: quizStore.state,
        };
    },
    methods: {
        submitForm() {
            if (TRAFFIC_SOURCE_EXOCLICK === this.trafficSource) {
                this.trafficSource = ADBLOCK_EXOCLICK;
            }
            if (TRAFFIC_SOURCE_PROPELLER === this.trafficSource) {
                this.trafficSource = ADBLOCK_PROPELLER;
            }

            let formData = new FormData();
            formData.append('category_id', this.categoryId);
            formData.append('host_id', this.$globalConstants.host.id);
            formData.append('traffic_source', this.trafficSource);
            formData.append('data', JSON.stringify(this.selectedOptions));
            formData.append('device_type', this.$globalConstants.deviceType);
            formData.append('t', this.$globalConstants.userId);
            formData.append('clId', this.$globalConstants.clickinId);
            formData.append(
                'quiz_tag_logic',
                this.$globalConstants.host.quiz_tag_logic
            );

            let quiz_answers = this.selectedOptions.join(' ');
            if (window.localStorage !== undefined) {
                window.localStorage.setItem('quiz_answers', quiz_answers);
            }
            formData.append('quiz_answers', quiz_answers);

            if (
                this.storeState.psh &&
                Boolean(this.storeState.psh['reload_page_after_quiz'])
            ) {
                this.$eventHub.$emit('reload-partners', quiz_answers);
            }

            window.axios
                .post(`/quiz/tags/result`, formData, {
                    headers: {
                        'Content-type': 'application/x-www-form-urlencoded',
                    },
                })
                .then((response) => {
                    if (
                        response.data.stat !== 'error, questionnaire not found'
                    ) {
                        this.result.partner = response.data.partner;
                        this.result.partnerProperties =
                            response.data.partnerProperties;
                        store.setPsh(response.data.partnerSet);
                        this.result.clickout = response.data.clickout;
                        this.loadResults = false;
                        this.showResults = true;
                    } else {
                        this.quizState.showQuestionnaire = false;
                        this.quizState.loadQuizFirst = false;
                    }
                });
        },
    },
};
